import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import React, { Component } from "react";
import { Animated } from "react-animated-css";
import stepStyles from "./Step.module.css";
import {
  faFileAlt,
  faIdCard,
  faMapPin,
  faSearch,
  faPassport,
  faPenAlt,
  faAt,
} from "@fortawesome/free-solid-svg-icons";
import Theme from "../../constants/Theme";
import { IconButton, Tooltip } from "@mui/material";
library.add(
  faIdCard,
  faMapPin,
  faPassport,
  faFileAlt,
  faSearch,
  faPenAlt,
  faAt
);

export default class Step extends Component {
  render() {
    const { steps, isActive } = this.props;
    return steps.map(function (item, i) {
      // console.log("test", i, isActive);
      return [
        <li key={i} className={stepStyles.itemStep}>
          <Tooltip title={item.name} placement="top">
            <IconButton
              // onClick={() => updateStepActive(i + 1)}
              aria-label=""
              style={
                isActive == i + 1
                  ? { color: "white", backgroundColor: Theme.COLORS.PRIMARY }
                  : { color: Theme.COLORS.LIGHT_GRAY, border: 0 }
              }
              className={`${stepStyles.stepIcon}`}
            >
              <FontAwesomeIcon
                style={{ fontSize: "20px" }}
                icon={`${item.emoji}`}
              />
            </IconButton>
          </Tooltip>
          <Animated
            animationIn="fadeInRight"
            animationOut="fadeInLeft"
            isVisible={isActive == i + 1 ? true : false}
            animationInDuration={200}
          >
            <div
              className={`${stepStyles.stepRight} ${
                isActive == i + 1 ? stepStyles.active : ""
              }`}
            >
              <div className={stepStyles.stepTopText}>
                Paso {i + 1}/{steps.length}
              </div>
              <div className={stepStyles.stepName}>{item.name}</div>
            </div>
          </Animated>
        </li>,
        <div
          key={`separator-${i}`}
          style={
            i != steps.length - 1
              ? {
                  backgroundColor: "rgba(50,50,50,0.2)",
                  height: "30px",
                  marginTop: "20px",
                  width: "1px",
                }
              : {}
          }
        ></div>,
      ];
    });
  }
}
